import DoneIcon from "@mui/icons-material/Done"
import CloseIcon from "@mui/icons-material/Close"
import CircularProgress from "@mui/material/CircularProgress"

export default function RuntimeCheck({
    isTyping,
    availablity,
    onClick,
    value,
    error,
    message,
    className,
}: {
    isTyping: boolean | null
    availablity: boolean | null
    onClick: () => void
    value: any
    error: any
    message?: string
    className?: string
}): JSX.Element {
    return (
        <>
            {(!error || (typeof error === 'string' && error)) && value !== "" && (
                <div
                    className={`absolute ${className} -right-4 flex items-center px-4 text-gray-600`}
                >
                    {isTyping !== null && !isTyping && (
                        <>
                            {availablity ? (
                                <DoneIcon className="text-greenSecondary mr-2" /> 
                            ) : (
                                <CloseIcon
                                    onClick={onClick}
                                    className="text-red-500 cursor-pointer mr-2"
                                />
                            )}
                        </>
                    )}
                    {isTyping && <CircularProgress size={20} className="mr-3" />}
                </div>
            )}
            {value !== "" && isTyping !== null && !isTyping && !availablity && (
                <div className="text-red-500 text-xs">
                    {" "}
                    {message}{" "}
                </div>
            )}
        </>
    )
}
